import { tenantApi as api } from '../config/api'
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    listLanguages: build.query<ListLanguagesApiResponse, ListLanguagesApiArg>({
      query: (queryArg) => ({
        url: `/languages/`,
        params: {
          display_in_ui: queryArg.displayInUi,
        },
      }),
    }),
    createLanguage: build.mutation<CreateLanguageApiResponse, CreateLanguageApiArg>({
      query: (queryArg) => ({ url: `/languages/`, method: 'POST', body: queryArg.createLanguageDto }),
    }),
    deleteLanguageByTag: build.mutation<DeleteLanguageByTagApiResponse, DeleteLanguageByTagApiArg>({
      query: (queryArg) => ({ url: `/languages/${queryArg.tag}`, method: 'DELETE' }),
    }),
    getLanguageByTag: build.query<GetLanguageByTagApiResponse, GetLanguageByTagApiArg>({
      query: (queryArg) => ({ url: `/languages/${queryArg.tag}` }),
    }),
  }),
  overrideExisting: false,
})
export { injectedRtkApi as enhancedApi }
export type ListLanguagesApiResponse = /** status 200 Successful Response */ LanguageDto[]
export type ListLanguagesApiArg = {
  /** If not provided, all languages will be returned.  */
  displayInUi?: boolean
}
export type CreateLanguageApiResponse = /** status 201 Successful Response */ LanguageDto
export type CreateLanguageApiArg = {
  createLanguageDto: CreateLanguageDto
}
export type DeleteLanguageByTagApiResponse = unknown
export type DeleteLanguageByTagApiArg = {
  tag: string
}
export type GetLanguageByTagApiResponse = /** status 200 Successful Response */ LanguageDto
export type GetLanguageByTagApiArg = {
  tag: string
}
export type LanguageDto = {
  display_in_ui: boolean
  display_name: string
  tag: string
}
export type ValidationError = {
  loc: (string | number)[]
  msg: string
  type: string
}
export type HttpValidationError = {
  detail?: ValidationError[]
}
export type CreateLanguageDto = {
  display_name: string
  tag: string
}
export const {
  useListLanguagesQuery,
  useCreateLanguageMutation,
  useDeleteLanguageByTagMutation,
  useGetLanguageByTagQuery,
} = injectedRtkApi
